/** @jsxImportSource @emotion/react */
import { useLingui } from '@lingui/react/macro';
import { Search } from 'lucide-react';
import { STATUS_FILTER_OPTIONS } from 'modules/roles-manager/domain/interfaces/status';
import React, { useMemo } from 'react';
import type { DivProps } from 'typings';
import { UDSelect } from 'ud-form/components';
import UDInput from 'ud-form/components/input/component';
import Label from 'ud-ui/components/label';
import UDPerPage from 'ud-ui/components/per-page/per-page';
import * as S from './styles';

interface IHeaderProps extends DivProps {
  perPage: number;
  search: string | null;
  status: boolean | null;
  phone: string | null;
  onChangePerPage: (value: number) => void;
  onChangeSearch?: (value: string) => void;
  onChangeStatus?: (value: boolean | null) => void;
  onChangePhone?: (value: string | null) => void;
}

function Header(props: IHeaderProps) {
  const { perPage, search, status, phone, onChangePerPage, onChangeSearch, onChangeStatus, onChangePhone, ...rest } = props;
  const { t } = useLingui();

  const statusOptions = useMemo(() => STATUS_FILTER_OPTIONS.map((option) => ({ ...option, label: t(option.label) })), [t]);

  return (
    <S.MainBlock {...rest}>
      <div className="flex gap-3.5">
        <Label text={t`Поиск по ФИО:`} className="w-[250px]">
          <UDInput
            value={search ?? ''}
            name="name"
            placeholder={t`Иванов Иван Иванович`}
            onChange={(value) => onChangeSearch?.(value.target.value)}
            iconProps={{
              component: <Search size={16} className="text-surfaceRomanSilver30" />,
              position: 'icon-right',
            }}
          />
        </Label>
        <Label text={t`Поиск по последним 4 циф. телефона:`} className="w-[310px]">
          <UDInput
            value={phone ?? ''}
            name="phone"
            placeholder={'0000'}
            onChange={(value) => onChangePhone?.(value.target.value)}
            iconProps={{
              component: <Search size={16} className="text-surfaceRomanSilver30" />,
              position: 'icon-right',
            }}
          />
        </Label>
        <Label text={t`Статус`} className="w-[160px]">
          <UDSelect
            value={statusOptions.find((o) => o.value === status) ?? statusOptions[0]}
            name="name"
            placeholder={t`Статус`}
            onChange={(option) => onChangeStatus?.(option?.value ?? null)}
            options={statusOptions}
            defaultValue={statusOptions[0]}
          />
        </Label>
      </div>
      <div className="flex w-1/2 items-end justify-end">
        <UDPerPage value={perPage} onChange={onChangePerPage} />
      </div>
    </S.MainBlock>
  );
}

export default Header;
